"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var ProgressBar_1 = __importDefault(require("../ProgressBar"));
var formatBytes_1 = require("../ImportFileModal/formatBytes");
var Icon_1 = __importDefault(require("../Icon"));
var __1 = require("../..");
var styles_1 = require("./styles");
var EmptyUploadFileItem_1 = require("./EmptyUploadFileItem");
var CircleContainer_1 = __importDefault(require("../CircleContainer"));
var UploadFileItem = function (props) {
    var id = props.id, name = props.name, size = props.size, status = props.status, progress = props.progress, tryAgainLabel = props.tryAgainLabel, error = props.error, onCancel = props.onCancel, onDelete = props.onDelete, onTryAgain = props.onTryAgain, isProgressBarHidden = props.isProgressBarHidden;
    var isMobile = (0, __1.useMediaQuery)({ device: 'mobileSm', filter: 'max' });
    // Show 'finished' view 1 second after status becomes COMPLETED
    var _a = (0, react_1.useState)(false), showFinished = _a[0], setShowFinished = _a[1];
    (0, react_1.useEffect)(function () {
        if (status === 'COMPLETED') {
            var timer_1 = setTimeout(function () {
                setShowFinished(true);
            }, 1000);
            return function () { return clearTimeout(timer_1); };
        }
        setShowFinished(false);
        return function () { return null; };
    }, [status]);
    var iconJsx = ((0, jsx_runtime_1.jsx)(styles_1.IconContainer, { children: (0, jsx_runtime_1.jsx)(CircleContainer_1.default, { children: (0, jsx_runtime_1.jsx)(__1.MaterialIcon, { name: "text_snippet", size: isMobile ? 's' : 'm' }) }) }));
    /// Show empty browse file state
    if (!id) {
        return (0, jsx_runtime_1.jsx)(EmptyUploadFileItem_1.EmptyUploadFileItem, __assign({}, props, { iconJsx: iconJsx, isMobile: isMobile }));
    }
    var nameJsx = ((0, jsx_runtime_1.jsx)(styles_1.BodyTitle, __assign({ size: isMobile ? 'md' : 'lg', "data-testid": "upload-file-name" }, { children: name })));
    /// Show finished deletable state
    if (showFinished) {
        return ((0, jsx_runtime_1.jsxs)(styles_1.Container, { children: [iconJsx, (0, jsx_runtime_1.jsx)(styles_1.Content, { children: nameJsx }), onDelete && ((0, jsx_runtime_1.jsx)(styles_1.ActionIcon, __assign({ onClick: onDelete, "data-testid": "upload-file-delete" }, { children: (0, jsx_runtime_1.jsx)(Icon_1.default, { name: "trash-can-outline", size: "m" }) })))] }));
    }
    var cancelCloseJsx = onCancel ? ((0, jsx_runtime_1.jsx)(styles_1.TopRightIcon, { children: (0, jsx_runtime_1.jsx)(styles_1.ActionIcon, __assign({ onClick: onCancel, "data-testid": "upload-file-cancel" }, { children: (0, jsx_runtime_1.jsx)(Icon_1.default, { name: "close", size: "m" }) })) })) : null;
    var hasFailed = status === 'FAILED';
    /// Show failed state
    if (hasFailed) {
        return ((0, jsx_runtime_1.jsxs)(styles_1.Container, __assign({ failedOutlined: true }, { children: [iconJsx, (0, jsx_runtime_1.jsxs)(styles_1.Content, { children: [nameJsx, (0, jsx_runtime_1.jsx)(styles_1.BodyErrorMsg, __assign({ size: isMobile ? 'md' : 'lg' }, { children: error })), onTryAgain && ((0, jsx_runtime_1.jsx)(styles_1.BodyTryAgain, __assign({ size: isMobile ? 'md' : 'lg', bold: true, onClick: onTryAgain, "data-testid": "upload-file-tryagain" }, { children: tryAgainLabel })))] }), cancelCloseJsx] })));
    }
    /// Show in-progress states
    return ((0, jsx_runtime_1.jsxs)(styles_1.Container, __assign({ outlined: true }, { children: [iconJsx, (0, jsx_runtime_1.jsxs)(styles_1.Content, { children: [nameJsx, (0, jsx_runtime_1.jsx)(styles_1.BodySizeText, __assign({ size: isMobile ? 'md' : 'lg' }, { children: (0, formatBytes_1.formatBytes)(size) })), !isProgressBarHidden && (0, jsx_runtime_1.jsx)(ProgressBar_1.default, { progress: progress })] }), status === 'COMPLETED' ? ((0, jsx_runtime_1.jsx)(styles_1.TopRightIcon, { children: (0, jsx_runtime_1.jsx)(__1.MaterialIcon, { type: "filled", name: "check_circle", size: "m" }) })) : (cancelCloseJsx)] })));
};
exports.default = UploadFileItem;
